import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import WebRoute from "./routes/WebRoute";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <WebRoute />
      <Footer />
    </>
  );
}

export default App;
